import { useEffect } from 'react';
import { trim } from 'lodash';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { useProjectActions } from 'src/store';

import { DocumentViewStore, ListViewStore } from '../store';

const useDocumentState = createStateSelectorHook(DocumentViewStore, ['editorContent']);
const useListViewState = createStateSelectorHook(ListViewStore, ['generationResults']);

export const useMaintainProjectEmptyFlag = () => {
  const projectActions = useProjectActions();
  const { editorContent } = useDocumentState();
  const { generationResults } = useListViewState();

  useEffect(() => {
    // Do not do anything if project is already marked as non-empty
    if (!projectActions.isCurrentProjectEmpty()) {
      return;
    }

    const documentPresent = trim(editorContent) !== '';
    const generationsPresent = generationResults.length > 0;
    if (documentPresent || generationsPresent) {
      projectActions.markCurrentProjectAsNonEmpty();
    }
  }, [editorContent, generationResults, projectActions]);
};
